import { defineStore } from 'pinia'
import { useCreateForm, useEditForm } from "@/stores/_helpers.js";
import toasteventbus from "primevue/toasteventbus";

export const useFirmwareTestingDocumentsStore = defineStore('firmwareTestingDocuments', {
  state: () => ({
    data: undefined,
  }),
  getters: {
    getFirmwareTestingDocuments: (state) => state.data?.data,
  },
  actions: {
    async indexFirmwareTestingDocuments(params = {}) {
      try {
        const response = await axios.get('firmware-testing-documents', {params});
        this.data = response.data;
      } catch (error) {
        console.error(error.response);
        throw error.response;
      }
    },
    async createFirmwareTestingDocument(params = {}) {
      try {
        const response = await axios.get('firmware-testing-documents/create', {params});
        return useCreateForm(`firmware-testing-documents`, {...response.data, file: null});
      } catch (error) {
        console.error(error.response);
        throw error.response;
      }
    },
    async showFirmwareTestingDocument(firmwareTestingDocumentId, params = {}) {
      try {
        const response = await axios.get(`firmware-testing-documents/${ firmwareTestingDocumentId }`, {params});
        return response.data;
      } catch (error) {
        console.error(error.response);
        throw error.response;
      }
    },
    async editFirmwareTestingDocument(firmwareTestingDocumentId, params = {}) {
      try {
        const response = await axios.get(`firmware-testing-documents/${ firmwareTestingDocumentId }/edit`, {params});
        return useEditForm(`firmware-testing-documents/${ firmwareTestingDocumentId }`, response.data);
      } catch (error) {
        console.error(error.response);
        throw error.response;
      }
    },
    async deleteFirmwareTestingDocument(firmwareTestingDocumentId, params = {}) {
      try {
        const response = await axios.delete(`firmware-testing-documents/${ firmwareTestingDocumentId }`, {params});
        toasteventbus.emit('add', {
          summary: 'Firmware Testing Document Deleted',
          detail: `Firmware Testing Document has been deleted.`,
          severity: 'success',
          life: 3000
        });
      } catch (error) {
        console.error(error.response);
        throw error.response;
      }
    },
  },
});
